export const meses = [
   {value: 0, label: 'Ene', labelLong: 'Enero'},
   {value: 1, label: 'Feb', labelLong: 'Febrero'},
   {value: 2, label: 'Mar', labelLong: 'Marzo'},
   {value: 3, label: 'Abr', labelLong: 'Abril'},
   {value: 4, label: 'May', labelLong: 'Mayo'},
   {value: 5, label: 'Jun', labelLong: 'Junio'},
   {value: 6, label: 'Jul', labelLong: 'Julio'},
   {value: 7, label: 'Ago', labelLong: 'Agosto'},
   {value: 8, label: 'Sep', labelLong: 'Septiembre'},
   {value: 9, label: 'Oct', labelLong: 'Octubre'},
   {value: 10, label: 'Nov', labelLong: 'Noviembre'},
   {value: 11, label: 'Dic', labelLong: 'Diciembre'}
];
